import { type BoxLeadApiGateway } from "@modules/boxLead/gateway/boxLeadApiGateway"
import { LoggerService } from "@modules/common/logger/loggerService"
import { type BoxLeadDto, BoxLeadDtoSchema, LeadColumnToSort } from "@modules/boxLead/gateway/boxLeadDto"
import { type BoxLeadInputDto } from "@modules/boxLead/gateway/boxLeadInputDto"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { ColumnSortingOrder } from "@modules/types/datatableTypes"
import { type PaginatedWrapper } from "@modules/utils/paginated"

export class BoxLeadApi implements BoxLeadApiGateway {
  private baseUrl = "/box/members/leads"

  constructor(private api: ApiClient) {}

  async getBoxLeads(
    page = 0,
    size = 20,
    name?: string,
    sortBy?: LeadColumnToSort,
    sortOrder?: ColumnSortingOrder,
  ): Promise<PaginatedWrapper<BoxLeadDto>> {
    const result = await this.api.get<PaginatedWrapper<BoxLeadDto>>(`${this.baseUrl}`, {
      params: { page, size, name, columnToSort: sortBy, columnSortingOrder: sortOrder },
    })
    return {
      ...result.data,
      content: result.data.content.map((lead) => LoggerService.parseApiDto(BoxLeadDtoSchema, lead)),
    }
  }

  async getBoxLead(leadId: string): Promise<BoxLeadDto> {
    const result = await this.api.get<BoxLeadDto>(`${this.baseUrl}/${leadId}`)
    return LoggerService.parseApiDto(BoxLeadDtoSchema, result.data)
  }

  async createBoxLead(leadInput: BoxLeadInputDto): Promise<void> {
    await this.api.post(`${this.baseUrl}`, leadInput)
  }

  async updateBoxLead(leadId: string, leadInput: BoxLeadInputDto): Promise<void> {
    await this.api.put(`${this.baseUrl}/${leadId}`, leadInput)
  }

  async deleteBoxLead(leadId: string): Promise<void> {
    await this.api.delete(`${this.baseUrl}/${leadId}`)
  }

  async mergeBoxLead(leadId: string, userId: string): Promise<void> {
    await this.api.put(`${this.baseUrl}/${leadId}/userId/${userId}`)
  }
}
